import React, { useEffect, useState } from "react"
import { Row, Col, Button } from "antd"
import Cookies from "js-cookie"

import CustomCookieModal from "../CustomCookieModal"
import { checkCookies } from "../../utilities/check-cookies"
import { COOKIES } from "../../enum"
import { reInitializeGA } from "../../utilities/google-analytics"

const Cookie = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [close, setClose] = useState(() => {
    if (typeof window !== "undefined") {
      const localData = localStorage.getItem("rhrCookies")
      return localData ? false : true
    }
  })

  const cookieState = Cookies.get(COOKIES.PERFORMANCE_COOKIES)
  const [cookie, setIsCookie] = useState<boolean>(false)
  useEffect(() => setIsCookie(cookieState === "true"), [cookieState, cookie])

  const cookies = () => {
    checkCookies()
    if (cookie === true) {
      reInitializeGA()
    }
    setClose(false)
    setIsVisible(false)
    if (typeof window !== "undefined") {
      localStorage.setItem("rhrCookies", "false")
    }
  }

  return (
    <>
      {close && (
        <Row
          className="cookie-container"
          style={close ? {} : { opacity: 0, position: "absolute", zIndex: -1 }}
        >
          <Col xl={16} className="cookie-details">
            <p>
              <strong>Cookie Policy</strong>
            </p>
            <p>
              This site uses cookies to function. If you give us your consent,
              we will also use cookies, when you visit our website, which will
              allow us to collect data for aggregated statistics to improve our
              services, analyze web traffic, facilitate our marketing efforts,
              provide you personalized content and advertisements, and the best
              user experience. You may visit our{" "}
              <a
                style={{ textDecoration: "underline" }}
                href="/data-privacy-and-cookies-policy"
                target="_blank"
              >
                Cookies Policy
              </a>{" "}
              page for more information or to change your preferences.
            </p>
          </Col>
          <Col className="cookie-buttons">
            <Button
              className="rhr-btn decline"
              onClick={() => setIsVisible(true)}
            >
              Manage Cookies
            </Button>
            <Button
              type="primary"
              className="cookie-button"
              onClick={() => {
                cookies()
                Cookies.set(COOKIES.PERFORMANCE_COOKIES, "true")
              }}
            >
              Accept Cookies
            </Button>
          </Col>
        </Row>
      )}

      <CustomCookieModal
        visible={isVisible}
        onOk={cookies}
        closable={false}
        maskClosable={false}
        onCancel={() => setIsVisible(false)}
      />
    </>
  )
}

export default Cookie
